function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o);
}
var _excluded = ["locations", "disabledNodes", "disableWholeTree", "treeDataSimpleMode", "showPath", "multiple", "placeholder"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t)
    return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i))
        return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
} return ("string" === r ? String : Number)(t); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
    var o, i = p[t], d = G.p, l = i[2];
    r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
} if (o || r > 1)
    return a; throw y = !0, n; } return function (o, p, l) { if (f > 1)
    throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
    i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
    try {
        if (f = 2, i) {
            if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u)))
                    throw TypeError("iterator result is not an object");
                if (!t.done)
                    return t;
                u = t.value, c < 2 && (c = 0);
            }
            else
                1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
            i = e;
        }
        else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a)
            break;
    }
    catch (t) {
        i = e, c = 1, u = t;
    }
    finally {
        f = 1;
    }
} return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() { } function GeneratorFunction() { } function GeneratorFunctionPrototype() { } t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try {
    i({}, "", {});
}
catch (e) {
    i = 0;
} _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { if (r)
    i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n;
else {
    var o = function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); };
    o("next", 0), o("throw", 1), o("return", 2);
} }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try {
    var i = n[a](c), u = i.value;
}
catch (n) {
    return void e(n);
} i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) {
    if ("string" == typeof r)
        return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
} }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++)
    n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) {
    var e, n, i, u, a = [], f = !0, o = !1;
    try {
        if (i = (t = t.call(r)).next, 0 === l) {
            if (Object(t) !== t)
                return;
            f = !1;
        }
        else
            for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0)
                ;
    }
    catch (r) {
        o = !0, n = r;
    }
    finally {
        try {
            if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u))
                return;
        }
        finally {
            if (o)
                throw n;
        }
    }
    return a;
} }
function _arrayWithHoles(r) { if (Array.isArray(r))
    return r; }
function _objectWithoutProperties(e, t) { if (null == e)
    return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    for (r = 0; r < n.length; r++)
        o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
} return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r)
    return {}; var t = {}; for (var n in r)
    if ({}.hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n))
            continue;
        t[n] = r[n];
    } return t; }
import React, { useEffect, useState } from "react";
import { Location } from "../../services/api";
import { getLocationsAsAntDTree, parseToAntDTree } from "../../utils";
import { TreeSelect } from "../TreeSelect";
import { jsx as _jsx } from "react/jsx-runtime";
var TreeSelectLocationComponent = function TreeSelectLocationComponent(props) {
    var locations = props.locations, _props$disabledNodes = props.disabledNodes, disabledNodes = _props$disabledNodes === void 0 ? [] : _props$disabledNodes, _props$disableWholeTr = props.disableWholeTree, disableWholeTree = _props$disableWholeTr === void 0 ? true : _props$disableWholeTr, _props$treeDataSimple = props.treeDataSimpleMode, treeDataSimpleMode = _props$treeDataSimple === void 0 ? true : _props$treeDataSimple, showPath = props.showPath, _props$multiple = props.multiple, multiple = _props$multiple === void 0 ? false : _props$multiple, _props$placeholder = props.placeholder, placeholder = _props$placeholder === void 0 ? 'Select Location' : _props$placeholder, restProps = _objectWithoutProperties(props, _excluded);
    console.log('TreeSelectLocation - placeholder:', placeholder);
    console.log('TreeSelectLocation - all props:', props);
    var _useState = useState([]), _useState2 = _slicedToArray(_useState, 2), treeData = _useState2[0], setTreeData = _useState2[1];
    useEffect(function () {
        var fetchTreeData = /*#__PURE__*/ function () {
            var _ref = _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee() {
                var fetchedTree;
                return _regenerator().w(function (_context) {
                    while (1)
                        switch (_context.n) {
                            case 0:
                                if (!(locations && locations.length > 0)) {
                                    _context.n = 1;
                                    break;
                                }
                                setTreeData(locations);
                                _context.n = 3;
                                break;
                            case 1:
                                _context.n = 2;
                                return getLocationsAsAntDTree(disabledNodes, disableWholeTree, true);
                            case 2:
                                fetchedTree = _context.v;
                                setTreeData(fetchedTree);
                            case 3:
                                return _context.a(2);
                        }
                }, _callee);
            }));
            return function fetchTreeData() {
                return _ref.apply(this, arguments);
            };
        }();
        if (treeData.length == 0)
            fetchTreeData();
    }, [locations, disabledNodes, disableWholeTree]); // Dependências do useEffect
    return /*#__PURE__*/ _jsx(TreeSelect, _objectSpread(_objectSpread({}, restProps), {}, {
        treeData: treeData,
        placeholder: placeholder,
        treeDataSimpleMode: treeDataSimpleMode,
        showPath: showPath,
        multiple: multiple
    }));
};
export var TreeSelectLocationBase = function TreeSelectLocationBase(props) {
    var baseLocation = props.baseLocation, languageId = props.languageId, _props$includeDirectP = props.includeDirectParents, includeDirectParents = _props$includeDirectP === void 0 ? true : _props$includeDirectP, _props$disabledNodes2 = props.disabledNodes, disabledNodes = _props$disabledNodes2 === void 0 ? [] : _props$disabledNodes2, _props$disableWholeTr2 = props.disableWholeTree, disableWholeTree = _props$disableWholeTr2 === void 0 ? true : _props$disableWholeTr2, _props$multiple2 = props.multiple, multiple = _props$multiple2 === void 0 ? false : _props$multiple2;
    var getTree = React.useCallback(/*#__PURE__*/ _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee2() {
        var response;
        return _regenerator().w(function (_context2) {
            while (1)
                switch (_context2.n) {
                    case 0:
                        if (!baseLocation) {
                            _context2.n = 2;
                            break;
                        }
                        _context2.n = 1;
                        return Location.get(baseLocation, languageId, true, includeDirectParents);
                    case 1:
                        response = _context2.v;
                        return _context2.a(2, parseToAntDTree([response.data.response], disabledNodes, disableWholeTree, false, true));
                    case 2:
                        return _context2.a(2);
                }
        }, _callee2);
    })), [baseLocation, languageId, includeDirectParents, disabledNodes, disableWholeTree]);
    return /*#__PURE__*/ _jsx(TreeSelectLocationComponent, _objectSpread({
        getTree: getTree,
        multiple: multiple
    }, props));
};
export var TreeSelectLocation = /*#__PURE__*/ React.memo(TreeSelectLocationComponent);
export { TreeSelectLocationCompany } from "./company";
export { TreeSelectLocationUser } from "./user";
